import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, TemplateRef } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as moment from "moment";
import * as _ from "lodash";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: 'app-scroll-search-souscripteur',
  templateUrl: './scroll-search-souscripteur.component.html',
  styleUrls: ['./scroll-search-souscripteur.component.scss']
})
export class ScrollSearchSouscripteurComponent implements OnInit {

  items: Array<any> = [];
  user: any = {};
  currentPage: number = 0;
  itemsPerPage: number = 10;
  busyGet: Subscription;
  searchKeySouscripteur: any = "";
  souscripteur_id: any
  @Input() current_souscripteur_id: any;
  @Input() clearText: any;
  @Output() onSelectSouscripteur = new EventEmitter();
  constructor(
    private authService: AuthService,
    private restClient: RestClientService,
  ) {
    // this.user = this.authService.currentUserValue;
    this.user = this.authService.getCurrentUser();

  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes.current_souscripteur_id && changes.current_souscripteur_id.currentValue) {
      this.souscripteur_id = changes.current_souscripteur_id.currentValue;
    }
    if (changes.clearText && changes.clearText.currentValue) {
      this.clearSelection()
    }
    this.itemsPerPage = 10
    this.getItems()
  }
  onSearch(event) {
    console.log("fkdkfjkd", event);
    this.itemsPerPage = 10;
    this.searchKeySouscripteur = event.term;
    if (event.term.length)
      this.getItems();
  }

  clearSelection() {
    this.souscripteur_id = null; // or undefined
    this.items = []
    this.searchKeySouscripteur = ''
  }


  onGetMoreItems() {
    this.itemsPerPage += 5;
    this.getItems();
  }


  onSelectElement() {

    this.onSelectSouscripteur.emit(this.souscripteur_id)

  }

  getItems() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: this.itemsPerPage,
      search_key: this.searchKeySouscripteur,
      data: {

      },
    };

    this.busyGet = this.restClient
      .post("souscripteur/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.items = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.items = [];
          }
        },
        (err) => {
          this.items = [];
        }
      );
  }



  onSelectTypePrestataire() { }

  ngOnInit() {
  }

}
